import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IconName } from '@sc/data-access-assets';
import { SpinnerComponent } from '../spinner/spinner.component';
import { IconComponent } from '../icon/icon.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'sc-button-vehicle-type',
  styleUrls: ['./button-vehicle-type.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <button
      type="button"
      [class.selected]="selected"
      [attr.aria-label]="ariaLabel"
      [attr.aria-labelledby]="ariaLabelledBy"
      [attr.role]="ariaRole"
    >
      <div class="btn-icons">
        <sc-icon
          *ngIf="leftIcon && !loading"
          [name]="leftIcon.name"
          [specificName]="leftIcon.specificName"
          [forceInitialColor]="!selected"
        ></sc-icon>
        <sc-icon
          *ngIf="rightIcon && !loading"
          class="rightIcon"
          [name]="rightIcon.name"
          [specificName]="rightIcon.specificName"
          [forceInitialColor]="!selected"
        ></sc-icon>
      </div>
      <sc-spinner *ngIf="loading"></sc-spinner>
      <div class="content">
        <ng-content *ngIf="!loading"></ng-content>
      </div>
    </button>
  `,
  imports: [NgIf, IconComponent, SpinnerComponent],
})
export class ButtonVehicleTypeComponent {
  @Input() leftIcon: { name: IconName; specificName?: string };
  @Input() rightIcon: { name: IconName; specificName?: string };
  @Input() loading = false;
  @Input() selected = false;
  @Input() ariaLabel: string;
  @Input() ariaLabelledBy: string;
  @Input() ariaRole: string;
}
